(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["power-footer"] && !Shopify.designMode) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-slideshow"] && !Shopify.designMode) return;
  try {
    
  class SplitSlideshowPanel extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.slides = [];
      this.dots = [];
      this.timer = null;
      this.isPaused = false;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.split-slideshow__slide'));
      this.dots = Array.from(this.querySelectorAll('.split-slideshow__dot'));
      this.prevBtn = this.querySelector('[data-direction="prev"]');
      this.nextBtn = this.querySelector('[data-direction="next"]');
      this.playToggle = this.querySelector('.split-slideshow__play-toggle');
      this.track = this.querySelector('.split-slideshow__track');

      if (this.slides.length <= 1) return;

      // Initialize first slide
      this.slides[0].classList.add('is-active');

      // Bind events
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(1));
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const target = parseInt(dot.dataset.slideTarget, 10);
          this.goTo(target);
        });
      });

      if (this.playToggle) {
        this.playToggle.addEventListener('click', () => this.togglePlay());
      }

      // Keyboard navigation when track is focused
      this.track.setAttribute('tabindex', '-1');
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.go(-1);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.go(1);
        }
      });

      // Touch/swipe support
      this.addTouchSupport();

      // Pause on hover (desktop) and on focus
      this.addEventListener('mouseenter', () => this.pause(true));
      this.addEventListener('mouseleave', () => this.pause(false));
      this.addEventListener('focusin', () => this.pause(true));
      this.addEventListener('focusout', (e) => {
        if (!this.contains(e.relatedTarget)) this.pause(false);
      });

      // Pause when not visible
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.isPaused) {
              this.startAutoplay();
            } else {
              this.stopAutoplay();
            }
          });
        },
        { threshold: 0.25 }
      );
      this.observer.observe(this);

      // Start autoplay if enabled and motion allowed
      if (this.dataset.autoplay === 'true' && !this.prefersReducedMotion) {
        this.startAutoplay();
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();
      if (this.observer) this.observer.disconnect();
    }

    go(direction) {
      const next = (this.currentIndex + direction + this.slides.length) % this.slides.length;
      this.goTo(next);
    }

    goTo(index) {
      if (index === this.currentIndex) return;

      this.slides[this.currentIndex].classList.remove('is-active');
      this.slides[this.currentIndex].setAttribute('aria-hidden', 'true');
      this.dots[this.currentIndex]?.classList.remove('is-active');
      this.dots[this.currentIndex]?.removeAttribute('aria-current');

      this.currentIndex = index;

      this.slides[this.currentIndex].classList.add('is-active');
      this.slides[this.currentIndex].setAttribute('aria-hidden', 'false');
      this.dots[this.currentIndex]?.classList.add('is-active');
      this.dots[this.currentIndex]?.setAttribute('aria-current', 'true');

      // Restart autoplay timer on manual interaction
      if (this.timer) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    startAutoplay() {
      if (this.dataset.autoplay !== 'true') return;
      if (this.prefersReducedMotion) return;
      if (this.isPaused) return;
      this.stopAutoplay();
      const interval = parseInt(this.dataset.interval, 10) || 5000;
      this.timer = setInterval(() => this.go(1), interval);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    pause(state) {
      this.isPaused = state;
      if (state) {
        this.stopAutoplay();
      } else if (this.playToggle?.dataset.state !== 'paused') {
        this.startAutoplay();
      }
    }

    togglePlay() {
      if (!this.playToggle) return;
      const isPlaying = this.playToggle.dataset.state === 'playing';
      if (isPlaying) {
        this.playToggle.dataset.state = 'paused';
        this.playToggle.setAttribute('aria-label', 'Play slideshow');
        this.stopAutoplay();
      } else {
        this.playToggle.dataset.state = 'playing';
        this.playToggle.setAttribute('aria-label', 'Pause slideshow');
        this.startAutoplay();
      }
    }

    addTouchSupport() {
      let startX = 0;
      let startY = 0;
      let dx = 0;
      let dy = 0;

      this.track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        dx = 0;
        dy = 0;
      }, { passive: true });

      this.track.addEventListener('touchmove', (e) => {
        dx = e.touches[0].clientX - startX;
        dy = e.touches[0].clientY - startY;
      }, { passive: true });

      this.track.addEventListener('touchend', () => {
        // Only trigger if horizontal swipe is dominant and over threshold
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          this.go(dx < 0 ? 1 : -1);
        }
      });
    }
  }

  if (!customElements.get('split-slideshow-panel')) {
    customElements.define('split-slideshow-panel', SplitSlideshowPanel);
  }

  } catch(e) { console.error(e); }
})();
})();
